import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// status: 'loading' | 'live' | 'offline' | 'unknown'
export function useStreamStatus() {
  const [s, setS] = useState({ status: 'loading' });
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/stream/status`);
        if (active) setS(data);
      } catch (e) {
        if (active) setS({ status: 'unknown' });
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { active = false; clearInterval(id); };
  }, []);
  return s;
}

export async function fetchFeaturedClip() {
  const { data } = await axios.get(`${API}/stream/clip`);
  return data;
}
